/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'
import Image from '@boltui/image'

import useMedia from '../../helpers/useMedia'
import styles from './ArgosCardPrompt.scss'

const argosCardImage = {
  ALT:
    'Spread the cost with an argos card credit play. Representative 29.9% apr variable. Click now to apply for an Argos Card.',
  DESKTOP: 'https://media.4rgos.it/i/Argos/argoscard-desktop?w=1140',
  TABLET: 'https://media.4rgos.it/i/Argos/argoscard-tablet?w=768',
  MOBILE: 'https://media.4rgos.it/i/Argos/argoscard-mobile?w=481',
}

const ArgosCardPrompt = ({ history }) => {
  const argosCardImg = useMedia(
    [argosCardImage.DESKTOP, argosCardImage.TABLET, argosCardImage.TABLET, argosCardImage.MOBILE],
    null,
  )

  return (
    <div className='container'>
      <div
        role='button'
        tabIndex='0'
        onClick={() => history.push('/help/argos-card?tag=ar:homepage:argoscardbanner')}
        className={styles['argos-card']}
        data-test='link-argos-card'>
        <span className='sr-only'>
          Spread the cost with an Argos Card Credit plan. Representative 29.9% APR variable. Credit subject to status.
          T&Cs apply. Click here to find out and learn more.
        </span>
        {argosCardImg && (
          <Image src={argosCardImg} data-test={'image-argos-card'} lazy className={styles['argos-card-image']} />
        )}
      </div>
    </div>
  )
}

ArgosCardPrompt.propTypes = {
  history: PropTypes.shape({
    action: PropTypes.oneOf(['PUSH', 'REPLACE', 'POP']).isRequired,
    block: PropTypes.func.isRequired,
    canGo: PropTypes.func,
    createHref: PropTypes.func.isRequired,
    entries: PropTypes.arrayOf(location),
    go: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    goForward: PropTypes.func.isRequired,
    index: PropTypes.number,
    length: PropTypes.number,
    listen: PropTypes.func.isRequired,
    location: location.isRequired,
    push: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired,
  }),
}

export default ArgosCardPrompt
